import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CONTACT_GET_ONE } from 'api/query-keys.ts';
import type { ContactRes } from 'api/swagger';

export const useGetContact = (id?: number) => {
  return useQuery<ContactRes>({
    queryKey: [CONTACT_GET_ONE, id],
    queryFn: async () => {
      const { data } = await http.get<ContactRes>(`/v1/contacts/${id}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    cacheTime: 60 * 1000,
    enabled: !!id,
  });
};
